// Email signup → Klaviyo
function handleSignup(e) {
  e.preventDefault();
  const email = document.getElementById('email-input').value;
  const msg = document.getElementById('signup-msg');
  const btn = e.target.querySelector('button[type="submit"]');

  btn.textContent = 'sending...';
  btn.disabled = true;

  const data = {
    data: {
      type: 'subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: { email: email }
          }
        }
      },
      relationships: {
        list: {
          data: { type: 'list', id: 'UeARxZ' }
        }
      }
    }
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VMXu67', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2023-12-15'
    },
    body: JSON.stringify(data)
  })
  .then(r => {
    if (r.ok || r.status === 202) {
      msg.style.color = '#0A0A0A';
      msg.textContent = '✅ thanks hottie';
      document.getElementById('email-input').value = '';
    } else {
      msg.style.color = '#E8000D';
      msg.textContent = 'something went wrong, try again!';
    }
  })
  .catch(() => {
    msg.style.color = '#E8000D';
    msg.textContent = 'something went wrong, try again!';
  })
  .finally(() => {
    btn.textContent = "I'M IN 🐾";
    btn.disabled = false;
    setTimeout(() => msg.textContent = '', 4000);
  });
}
